import React from 'react'
import { useParams } from 'react-router-dom'
import RevshareParticipantHeader from '../components/RevshareParticipantHeader'
import RevshareMonthlySummaryPanel from '../components/RevshareMonthlySummaryPanel'
import RevshareParticipantPayoutsPanel from '../components/RevshareParticipantPayoutsPanel'
import RevshareParticipantBankAccountsPanel from '../components/RevshareParticipantBankAccountsPanel'

export default function RevshareParticipantDetailsPage() {
  const { id } = useParams()
  const [refreshKey, setRefreshKey] = React.useState(0)

  if (!id) return null

  return (
    <div className="mx-auto w-full max-w-[1550px] p-4">
      <RevshareParticipantHeader userId={id} />

      <RevshareMonthlySummaryPanel
        userId={id}
        refreshKey={refreshKey}
        onPayoutChanged={() => setRefreshKey((n) => n + 1)}
      />
      <RevshareParticipantPayoutsPanel userId={id} refreshKey={refreshKey} />
      <RevshareParticipantBankAccountsPanel userId={id} />
    </div>
  )
}

